export const getCookieValidityDomain = ({
  origin,
}: URL): string | undefined => {
  const match = origin.match(/\.?(develop|master|rossum)\.(.*)/)?.[0];

  if (!match) {
    return undefined;
  }

  return match.startsWith('.') ? match : `.${match}`;
};
